<app-ligthboxes-default id="custom-message" class="hidden"></app-ligthboxes-default>
<router-outlet></router-outlet>
